var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infoButton",on:{"mouseover":_vm.showHint,"mouseleave":_vm.hideHint}},[_c('img',{attrs:{"src":"https://sirvwebsite.sirv.com/assets/question.svg","alt":_vm.hint}}),_c('div',{staticClass:"hintWrapper hint"},[(_vm.status)?_c('div',{staticClass:"hintButton question"},[_vm._v(" "+_vm._s(_vm.hint)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }